import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { type CSSProperties } from "@mui/material/styles/createMixins";

export const Body = styled(Box)(
  ({ theme }): CSSProperties => ({
    backgroundColor: theme.palette.otherBackground.main,
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  })
);
